import React from 'react';
import ReactFlagsSelect from 'react-flags-select';
import { makeStyles } from '@material-ui/styles';

import { onClickWrapper } from '../../../utils/ui';

import expand from '../../../assets/img/icons/icons-content-expand-more-default.svg';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 0,

    '& > ul': {
      top: '100%',
      marginTop: 1,

      '& > li > span > span:last-of-type': {
        ...theme.typography.subtitle3,
        color: theme.palette.text.primary
      }
    }
  },
  button: {
    height: 32,
    padding: '0 8px',
    borderRadius: 8,
    border: 0,
    outline: 'none',

    '& > span': {
      margin: 0,
      padding: '0 8px 0 0',

      '& > span:last-of-type': {
        ...theme.typography.subtitle3,
        color: theme.palette.text.primary,

        '@supports (-webkit-hyphens:none)': {
          marginBottom: -1
        }
      }
    },

    '&:after, &[aria-expanded="true"]:after': {
      background: `url('${expand}')`,
      width: 16,
      height: 16,
      border: 'none',
      marginLeft: 0
    },
    '&[aria-expanded="true"]:after': {
      transform: 'rotate(180deg)'
    }
  }
}));

const countryFromFullCode = fullCode =>
  fullCode.substring(fullCode.indexOf('_') + 1).toUpperCase();

const FlagsSelect = ({ id, onChange, languages, value }) => {
  const classes = useStyles();

  const onSelectWrapper = code => {
    const fullCode = languages.find(
      l => countryFromFullCode(l.fullCode) === code
    ).fullCode;
    onClickWrapper(`${id}-${fullCode}`)();
    onChange && onChange(fullCode);
  };

  if (!languages || languages.length === 0) {
    return null;
  }

  return (
    <ReactFlagsSelect
      id={id}
      className={classes.root}
      selectButtonClassName={classes.button}
      countries={languages.map(l => countryFromFullCode(l.fullCode))}
      placeholder="&nbsp;"
      customLabels={languages.reduce(
        (acc, l) => ({
          ...acc,
          [countryFromFullCode(l.fullCode)]: l.language
        }),
        {}
      )}
      selected={value ? countryFromFullCode(value) : 'DE'}
      onSelect={onSelectWrapper}
    />
  );
};

export default FlagsSelect;
